import { containsHtml, sanitizeRichText, stripHtml } from '../../card-actions/utils/richText';
import type { WallCard } from '@walls/store';

export function getCardText(card: WallCard) {
  const text = card.title?.trim() || card.content?.trim() || '';

  return stripHtml(text);
}

export function getCardHtml(card: WallCard) {
  const text = card.title?.trim() || card.content?.trim() || '';

  return containsHtml(text) ? sanitizeRichText(text) : null;
}

export function getCardTitleText(card: WallCard) {
  return stripHtml(card.title?.trim() || '');
}

export function getCardTitleHtml(card: WallCard) {
  const title = card.title?.trim() || '';

  return containsHtml(title) ? sanitizeRichText(title) : null;
}

export function getCardShape(card: WallCard) {
  return card.shape?.trim().toLowerCase() || 'card';
}

export function getCardType(card: WallCard) {
  return card.type?.trim().toLowerCase() || 'text';
}

export function getCardDimensions(card: WallCard, fallbackWidth = 200, fallbackHeight?: number) {
  return {
    width: card.width ?? fallbackWidth,
    height: card.height ?? fallbackHeight,
  };
}

export function isImageCard(card: WallCard) {
  return getCardType(card) !== 'text';
}

export function isDarkCard(color?: string) {
  return color?.toLowerCase() === '#000000' || color?.toLowerCase() === '#ff0033';
}
